// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_mqo","cls2":"CreateSocialItemModal-cls2__T7 CreateSocialItemModal-cls1_mqo"};